import api from '~/services/api';
import PropTypes from 'prop-types';

const endPoint = 'services';

// GET
export const getServices = async (params, route = '') => {
  try {
    const { data } = await api.get(`/${endPoint}/${route}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// CREATE
export const createServices = async (values) => {
  try {
    const { data } = await api.post(`/${endPoint}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateServices = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteServices = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    return data.data;
  } catch (error) {
    throw error;
  }
};

getServices.propTypes = {
  params: PropTypes.object.isRequired,
};

createServices.propTypes = {
  values: PropTypes.object.isRequired,
};

updateServices.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteServices.propTypes = {
  id: PropTypes.string.isRequired,
};
